// pipe: the Dashboard sidebar entry (first in the ERP block). Gated server-side by `hasErp` on
// `/me/provisioning`: a doc-only user never sees it (the screen itself 403s/empties regardless).
import { useI18n } from '@affine/i18n';
import { DatabaseKanbanViewIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { useErpProvisioning } from '../../modules/erp';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const DashboardButton = () => {
  const t = useI18n();
  const provisioning = useErpProvisioning();
  const { workbenchService } = useServices({ WorkbenchService });
  const active = useNavPrefixActive(workbenchService.workbench, '/dashboard');
  if (!provisioning?.hasErp) {
    return null;
  }
  return (
    <MenuLinkItem icon={<DatabaseKanbanViewIcon />} active={active} to={'/dashboard'}>
      <span data-testid="pipe-dashboard-nav">
        {t['com.affine.pipe.dashboard.nav']()}
      </span>
    </MenuLinkItem>
  );
};
